'use client'

import Button from '@mui/material/Button'
import { type FC } from 'react'
import mlBuildingDesktop from '../../../public/assets/ml-building-desktop.png'
import mlBuildingMobile from '../../../public/assets/ml-building-mobile.jpg'
import events from '../../constants/analytics'
import HeroSection from '../../shared/components/HeroSection'
import JoinUsSection from '../../shared/components/JoinUsSection'
import { useAnalytics } from '../../shared/context/Analytics'
import useViewPage from '../../shared/hooks/useViewPage'
import { OurBenefitsSection, OurValuesSection, WhyWorkSection } from './components'

const CareersPage: FC = () => {
  useViewPage(events.EVENTS.INIT.ViewCareersPage)
  const { track } = useAnalytics()

  const getButton = (ctaName: string) => (
    <Button
      href="https://job-boards.greenhouse.io/missionlane"
      variant="contained"
      className="w-full md:w-fit"
      onClick={() => track?.(events.EVENTS.INTERACTION.ClickViewOpenings, { cta: ctaName })}
    >
      View Openings
    </Button>
  )

  return (
    <>
      <HeroSection
        title="Progress is our mission"
        imageSrc={mlBuildingDesktop}
        mobileImageSrc={mlBuildingMobile}
        imageAltText="Mission Lane office building exterior"
      >
        {getButton('Hero')}
      </HeroSection>
      <WhyWorkSection />
      <OurValuesSection />
      <OurBenefitsSection />
      <JoinUsSection>{getButton('Join us')}</JoinUsSection>
    </>
  )
}

export default CareersPage
